/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-implant-bill-item.reducer';

export const PharmacyImplantBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyImplantBillItemEntity = useAppSelector(state => state.pharmacyImplantBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyImplantBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.detail.title">PharmacyImplantBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.id}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.chargedMrp}</dd>
          <dt>
            <span id="qty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.qty">Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.qty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.expDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.lastupdated}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.discount}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.paidAmount}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.taxCode}</dd>
          <dt>
            <span id="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.cessAmount">Cess Amount</Translate>
            </span>
            <UncontrolledTooltip target="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.help.cessAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.cessAmount}</dd>
          <dt>
            <span id="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.exempted">Exempted</Translate>
            </span>
            <UncontrolledTooltip target="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.help.exempted" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.exempted ? 'true' : 'false'}</dd>
          <dt>
            <span id="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.freeQty">Free Qty</Translate>
            </span>
            <UncontrolledTooltip target="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.help.freeQty" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.freeQty}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.pharmacyBill">Pharmacy Bill</Translate>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.pharmacyBill ? pharmacyImplantBillItemEntity.pharmacyBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.pharmacyStock">Pharmacy Stock</Translate>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.pharmacyStock ? pharmacyImplantBillItemEntity.pharmacyStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.uqcType">Uqc Type</Translate>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.uqcType ? pharmacyImplantBillItemEntity.uqcType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.scheme">Scheme</Translate>
          </dt>
          <dd>{pharmacyImplantBillItemEntity.scheme ? pharmacyImplantBillItemEntity.scheme.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-implant-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-implant-bill-item/${pharmacyImplantBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyImplantBillItemDetail;
